/**
 * The sign-up pass: `POST /auth/otp/verify` answers a new phone with
 * `{ status: "new_user", signupToken }`, and `POST /auth/complete-profile`
 * must send that token back so only the app that verified the phone can
 * finish registering it (API: services/signup-pass.service.ts).
 *
 * Kept in memory only (lib/auth.tsx): it lives 15 minutes, and a restarted app
 * verifies the phone again anyway. An API from before the pass sends none;
 * the body then goes out exactly as before.
 */

/** The pass in an otp/verify answer, or null when there is none. */
export function signupTokenFrom(verifyBody: unknown): string | null {
    if (verifyBody == null || typeof verifyBody !== "object") {
        return null;
    }
    const token = (verifyBody as { signupToken?: unknown }).signupToken;
    return typeof token === "string" && token.length > 0 ? token : null;
}

/** The complete-profile body, with the pass when there is one. */
export function withSignupToken<T extends object>(
    body: T,
    signupToken: string | null
): T | (T & { signupToken: string }) {
    return signupToken ? { ...body, signupToken } : body;
}
